import { createContext } from "react";

import { noop } from "lodash";

import useDateTimeState from "~/calendar/hooks/useDateTimeState";
import type { RepeatOption } from "~/calendar/hooks/useRecurrenceOptions";

import type {
	CustomRecurringRuleSerializerInput,
	repeat as RepeatChoice,
} from "~/__generated__/useSaveEventMutationMutation.graphql";

export type EventFormContextType = {
	eventTitle: string;
	setEventTitle: (value: string) => void;

	eventPurpose: string;
	setEventPurpose: (value: string) => void;

	timeState: ReturnType<typeof useDateTimeState>[0];
	changeTime: ReturnType<typeof useDateTimeState>[1];

	repeatState: RepeatChoice;
	customRrule: CustomRecurringRuleSerializerInput | null;
	changeRecurrence: (value: RepeatChoice) => void;
	setRecurrenceFromRrule: (rrule: ReadonlyArray<string | null> | null) => void;
	repeatOptions: RepeatOption[];
};

export const EventFormContext = createContext<EventFormContextType>({
	eventTitle: "",
	setEventTitle: noop,
	eventPurpose: "",
	setEventPurpose: noop,
	timeState: {
		start: new Date(),
		end: new Date(),
		isAllDay: false,
		timezone: undefined,
	},
	changeTime: noop,
	repeatState: "NEVER",
	customRrule: null,
	changeRecurrence: noop,
	setRecurrenceFromRrule: noop,
	repeatOptions: [],
});
